import { render, staticRenderFns } from "./UpdateReleasePanel.vue?vue&type=template&id=934d8bc0"
import script from "./UpdateReleasePanel.vue?vue&type=script&lang=js"
export * from "./UpdateReleasePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports